import React from 'react';
import { Toast as PloneToast } from '@plone/components';
import { clsx } from 'clsx';
import './Toast.scss';

export interface ESSToastProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
  className?: string;
  content: string;
  [key: string]: any; // Allow any props from @plone/components Toast
}

/**
 * ESS Toast Component
 *
 * A notification component that displays temporary messages to users.
 * Wraps @plone/components Toast with ESS design system styling.
 *
 * Note: This component wraps @plone/components Toast in a styled div.
 * Check the @plone/components documentation for the full Toast API.
 *
 * @example
 * ```tsx
 * import { ESSToast } from './components/Atoms/Toast';
 *
 * // Basic usage - check @plone/components docs for exact API
 * <ESSToast variant="success" />
 * ```
 */
export const ESSToast: React.FC<ESSToastProps> = ({
  variant = 'info',
  className,
  content,
  ...props
}) => {
  return (
    <div className={clsx('ess-toast', `ess-toast--${variant}`, className)}>
      <PloneToast content={content} {...props} />
    </div>
  );
};

export default ESSToast;
